import * as Joi from 'joi';

export const JoiAuthForgotPasswordSubmit = Joi.object({
  username: Joi.string().regex(/^\S+$/).trim().required().messages({
    'string.pattern.base': 'Username cannot contain white space',
    'string.empty': 'Username cannot be empty',
    'string.required': 'Username is required'
  }),
  password: Joi.string()
    .regex(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)
    .min(8)
    .required()
    .messages({
      'string.pattern.base': 'Password must be least 8 characters with mix of upper and lowercase letters, numbers and special characters',
      'string.empty': 'Password cannot be empty',
      'string.required': 'Password is required',
      'string.min': 'Password must be at least 8 characters'
    }),
  code: Joi.string()
    .length(6)
    .pattern(/^[0-9]+$/)
    .required()
    .messages({
      'string.empty': 'Code cannot be empty',
      'string.required': 'Code is required',
      'string.length': 'Code must be 6 digits'
    })
}).options({ abortEarly: false });

export const JoiAuthSignup = Joi.object({
  username: Joi.string().regex(/^\S+$/).trim().required().messages({
    'string.pattern.base': 'Username cannot contain white space',
    'string.empty': 'Username cannot be empty',
    'string.required': 'Username is required'
  }),
  given_name: Joi.string().trim().required().messages({
    'string.empty': 'First name cannot be empty',
    'string.required': 'First name is required'
  }),
  family_name: Joi.string().trim().required().messages({
    'string.empty': 'Last name cannot be empty',
    'string.required': 'Last name is required'
  }),
  phone_number: Joi.string()
    .regex(/^\+1\d{10}$/)
    .required()
    .messages({
      'string.pattern.base': 'Phone is not filled out correctly',
      'string.empty': 'Phone cannot be empty',
      'string.required': 'Phone is required'
    }),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .trim()
    .lowercase()
    .messages({
      'string.empty': 'Email cannot be empty',
      'string.required': 'Email is required',
      'string.email': 'Not a valid email'
    }),
  password: Joi.string()
    .regex(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)
    .min(8)
    .required()
    .messages({
      'string.pattern.base': 'Password must be least 8 characters with mix of upper and lowercase letters, numbers and special characters',
      'string.empty': 'Password cannot be empty',
      'string.required': 'Password is required',
      'string.min': 'Password must be at least 8 characters'
    })
}).options({ abortEarly: false });
